import { Component } from '@angular/core';

@Component({
  selector: 'app-storybooks',
  imports: [],
  templateUrl: './storybooks.html',
  styleUrl: './storybooks.scss',
})
export class Storybooks {

}
